import React, { useState, useEffect } from "react";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import clsx from "clsx";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepConnector from "@material-ui/core/StepConnector";

import { TiInfoLarge } from "react-icons/ti";
import { FaRegAddressCard } from "react-icons/fa";
import { FcSelfie } from "react-icons/fc";
import { FaVideo } from "react-icons/fa";
import { BsCameraVideo } from "react-icons/bs";
import { TiTick } from "react-icons/ti";

export default function Milestones(props) {
  const classes = useStyles();
  const theme = useTheme();

  //   console.log("Milestone steps: ", props.stepsCompleted);

  const [activeStep, setActiveStep] = useState(4);
  const [completed, setCompleted] = useState({
    0: props.stepsCompleted.one,
    1: props.stepsCompleted.two,
    2: props.stepsCompleted.three,
    3: props.stepsCompleted.four,
    4: props.stepsCompleted.status === "approved" ? true : false,
  });

  function ColorlibStepIcon(step) {
    const classes = useColorlibStepIconStyles();

    const icons = {
      0: <TiInfoLarge style={{ fontSize: "25px" }} />,
      1: <FaRegAddressCard style={{ fontSize: "20px" }} />,
      2: <FaRegAddressCard style={{ fontSize: "20px" }} />,
      3: <FaVideo style={{ fontSize: "20px", fontColor: "white" }} />,
      4: <TiTick style={{ fontSize: "25px" }} />,
    };

    return (
      <div
        className={clsx(classes.root, {
          [classes.completed]: completed[step],
        })}
      >
        {icons[step]}
      </div>
    );
  }

  function capitalizeFirstLetter(string) {
    if (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    } else {
      return "Pending";
    }
  }

  useEffect(() => {
    setCompleted({
      0: props.stepsCompleted.one,
      1: props.stepsCompleted.two,
      2: props.stepsCompleted.three,
      3: props.stepsCompleted.four,
      4: props.stepsCompleted.status === "approved" ? true : false,
    });
  }, [props.stepsCompleted]);

  return (
    <div className={classes.root}>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<ColorlibConnector />}
        style={{ padding: 0 }}
      >
        <Step key="Step 1">
          <StepLabel StepIconComponent={() => ColorlibStepIcon(0)}>
            Basic Info
          </StepLabel>
        </Step>
        <Step key="Step 2">
          <StepLabel StepIconComponent={() => ColorlibStepIcon(1)}>
            PAN Card
          </StepLabel>
        </Step>
        <Step key="Step 3">
          <StepLabel StepIconComponent={() => ColorlibStepIcon(2)}>
            Secondary Identification
          </StepLabel>
        </Step>
        <Step key="Step 4">
          <StepLabel StepIconComponent={() => ColorlibStepIcon(3)}>
            Video Selfie
          </StepLabel>
        </Step>
        <Step key="Step 5">
          <StepLabel StepIconComponent={() => ColorlibStepIcon(4)}>
            {typeof props.stepsCompleted.status === "number"
              ? "Processing"
              : capitalizeFirstLetter(props.stepsCompleted.status)}
          </StepLabel>
        </Step>
      </Stepper>
    </div>
  );
}

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    "& $line": {
      backgroundImage:
        "linear-gradient( 136deg, #d9f0ea 0%, #3AC4AB 50%, #0b6c51 100%)",
    },
  },
  completed: {
    "& $line": {
      backgroundImage:
        "linear-gradient( 136deg, #d9f0ea 0%, #3AC4AB 50%, #0b6c51 100%)",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 40,
    height: 40,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
  },
  active: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundImage:
      "linear-gradient( 136deg, #e4fef7 0%, #3AC4AB 50%, #0b6c51 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginBottom: "40px",
    padding: 0,
    display: "flex",
    justifyContent: "center",
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));
